import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import CalendarToday from "@material-ui/icons/CalendarToday";
import { dateformat } from "../../../../../utils/dateFormat";
import { useDetailsInfoStyles } from "./styles";
import Grid from "@material-ui/core/Grid";
import PriorityIcon from "./components/priority-icon";
import { Priority } from "../../../../../@types/priority";

type DetailsInfoProps = {
    priority: Priority;
};

export default function DetailsInfo({ priority }: DetailsInfoProps) {
    const { classes } = useDetailsInfoStyles();

    return (
        <Paper elevation={3}>
            <Box className={classes.head}>
                <Box className={classes.container}>
                    <Box className={classes.header}>
                        <Typography className={classes.title}>
                            {priority?.nome}
                        </Typography>
                        <Box
                            className={`${classes.badge} ${priority?.ativo
                                ? classes.active
                                : classes.inactive
                                }`}
                            >
                            {priority?.ativo ? "Ativo" : "Inativo"}
                        </Box>
                    </Box>
                    <Box className={classes.infosContainer}>
                        <Box className={classes.infoContainer}>
                            <CalendarToday className={classes.icons} />
                            <Typography className={classes.infoContainerText}>
                                Adicionado: {dateformat(priority?.created_at, true)}
                            </Typography>
                        </Box>
                        <Box className={classes.infoContainer}>
                            <CalendarToday className={classes.icons} />
                            <Typography className={classes.infoContainerText}>
                                Atualizado em: {dateformat(priority?.updated_at, true)}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Divider />
            <Box className={classes.content}>
                <Typography className={classes.subtitle}>
                    Informações de prioridade
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={6} className={classes.priorityInfoContainer}>
                        <Typography className={classes.priorityInfoTitle}>
                            Peso
                        </Typography>
                        <Typography className={classes.priorityInfoText}>
                            {priority?.peso >= 0 ? priority?.peso  : "Nenhum peso informado."}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.priorityInfoContainer}>
                        <Typography className={classes.priorityInfoTitle}>
                            Descrição
                        </Typography>
                        <Typography className={classes.priorityInfoText}>
                            {priority?.descricao || "Nenhuma descrição informada."}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.priorityInfoContainer}>
                        <Typography className={classes.priorityInfoTitle}>
                            Cor da Fonte
                        </Typography>
                        <Typography className={classes.priorityInfoText}>
                            {priority?.cor_fonte || "Nenhuma cor informada."}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.priorityInfoContainer}>
                        <Typography className={classes.priorityInfoTitle}>
                            Cor de Tag
                        </Typography>
                        <Typography className={classes.priorityInfoText}>
                            {priority?.cor_tag || "Nenhuma cor informada."}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.priorityInfoContainer}>
                        <Typography className={classes.priorityInfoTitle}>
                            Sigla de Prioridade
                        </Typography>
                        <Typography className={classes.priorityInfoText}>
                            {priority?.sigla_senha || "Nenhuma sigla informada."}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.priorityInfoContainer}>
                        <Typography className={classes.priorityInfoTitle}>
                            Ícone
                        </Typography>
                        <PriorityIcon priority={priority} />
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
}
